/** A failed or malformed response must not be presented as an empty knowledge library. */
export function readKnowledgeDocumentList<T>(data: unknown): T[] {
    const records = Array.isArray(data)
        ? data
        : data && typeof data === 'object' && 'results' in data
        ? (data as { results: unknown }).results
        : null;
    if (
        !Array.isArray(records) ||
        records.some(
            (record) =>
                !record ||
                !['number', 'string'].includes(typeof record.id) ||
                !Number.isSafeInteger(Number(record.id)) ||
                Number(record.id) <= 0
        )
    ) {
        throw new Error('Некорректный ответ при загрузке баз знаний');
    }
    return records;
}
